import { NewCarInfoList as BaseNewCarInfoList } from '../info-list';
import { CarMakeInfoItem } from './item';
import styles from './styles.module.scss';
import type { Component } from './types';

export const CarMakeInfoList: Component = ({
  list,
}) => (
  <div className={styles.containerRoot}>
    <BaseNewCarInfoList>
      {
        list.map(({
          id,
          name,
          brand,
          type,
          isCommercial,
          hotlines: phoneArray,
          pricelistDates: priceList,
        }) => {
          const dealerInfo = {
            id,
            name,
            brand,
            type,
            phoneArray,
            priceList,
            isCommercial,
          };
          return (
            <CarMakeInfoItem
              key={id}
              dealerInfo={dealerInfo} />
          );
        })
      }
    </BaseNewCarInfoList>
  </div>
);
